
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shop/checkout",
      function () {
        return require("private-next-pages/shop/checkout/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shop/checkout"])
      });
    }
  